import { render, staticRenderFns } from "./ManageFlightsDropdown.vue?vue&type=template&id=0bfae5ab&"
import script from "./ManageFlightsDropdown.vue?vue&type=script&lang=js&"
export * from "./ManageFlightsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports